import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SelectedAccountUserFragment = { __typename?: 'AccountUser', id: string, name?: string | null, userId?: string | null, inviteEmailAddress?: string | null, displayName?: string | null, isCurrentUser?: boolean | null, licenseType?: Types.AccountUserLicenseTypeValue | null, accountUserType?: Types.AccountUserTypeEnum | null };

export const SelectedAccountUser = /*#__PURE__*/ gql`
    fragment SelectedAccountUser on AccountUser {
  id
  name
  userId
  inviteEmailAddress
  displayName @client
  isCurrentUser @client
  licenseType
  accountUserType
}
    ` as unknown as DocumentNode<SelectedAccountUserFragment, unknown>;

        

        
export const useSelectedAccountUserFragment = (
  input: string | Omit<UseFragmentOptions<SelectedAccountUserFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AccountUser' } };
    return input;
  })();

  return useFragment<SelectedAccountUserFragment>({
    fragment: SelectedAccountUser,
    fragmentName: 'SelectedAccountUser',
    ...options,
  });
};
  
        